import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ExpenseClaimPaymentMethod, ExpenseClaimViewModel } from 'app/core/models/expense.model';
import { Permissions } from "../../../../core/constants/permissions";
import { AuthService } from "../../../../core/services/auth.service";

@Component({
  selector: 'app-expense-details-head',
  templateUrl: './expense-details-head.component.html',
  styleUrls: ['./expense-details-head.component.scss']
})
export class ExpenseDetailsHeadComponent implements OnInit {
  @Input() expense: ExpenseClaimViewModel;
  @Input() dataLoaded: boolean;
  @Output() searchFilter: EventEmitter<{ id: string, label: string }> = new EventEmitter<{ id: string, label: string }>();
  @Output() trialFilter: EventEmitter<{ id: string, label: string }> = new EventEmitter<{ id: string, label: string }>();
  trialText: string;
  ExpenseClaimPaymentMethod = ExpenseClaimPaymentMethod;

  protected readonly authService = inject(AuthService);
  ngOnInit(): void {
    if(this.expense){
      this.setTrialText();
    }
  }

  private setTrialText() {
    this.trialText = this.expense.trialNickname ?
      `${this.expense.trialCode} ${this.expense.trialNickname} - ${this.expense.trialOracleCode}` :
      `${this.expense.trialCode} ${this.expense.trialOracleCode}`;
  }

  getPatientAddress(address: string | null, country: string | null): string {
    const formattedAddress = address ?? '';
    const lastTwoCharsOfAddress = formattedAddress.slice(-2);

    return country && country !== '' && country !== lastTwoCharsOfAddress
      ? `${formattedAddress}, ${country}`
      : formattedAddress;
  }

  filterExpenses(){
    this.searchFilter.emit({
      id: this.expense.patientId,
      label: `${this.expense.trialCode} | ${this.expense.patientCode} - ${this.expense.patientName}`
    });
  }

  filterByTrial(){
    this.trialFilter.emit({ id: this.expense.trialId, label: this.expense.trialCode });
  }

    protected readonly Permissions = Permissions;
}
